import { Box, Button, ButtonProps, Icon, Typography } from "@mui/material"
import { CustomPaper } from "../../../../../CustomPaper"
import { icons } from "../../../../../../utils/icons"
import { useContextState } from "../../../../../../hooks/theme"
import dayjs, { Dayjs } from "dayjs"
import { useMemo } from "react"
import { Constants } from "../../../../../../utils/constants"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        button: {
            width: '100%',
            minHeight: '70px',
            maxHeight: '90px',
            padding: '0px',
            //border:'1px solid red'
        },
        container: {
            width: '100%',
            height: '100%',
            padding: '10px',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            margin: '0px',
            position: 'relative',
        },
        title: {
            textAlign: 'left',
            fontSize: '12px',
            color: colors.color13,
        },
        icon: {
            fontSize: '1.8rem',
            fontWeight: '100',
            color: colors.color13,
            '& .MuiSvgIcon-root': {
                fontSize: 'inherit',
                fontWeight: '100',
            }
        },
        dates: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            '& .MuiTypography-root': {
                color: colors.color13,
                fontSize: '14px',
                fontWeight: 'bold'
            }
        },
        error: {
            '& .MuiTypography-root': {
                color: colors.color28,
            },
            '& .MuiIcon-root': {
                color: colors.color28,
            },
            '& .MuiPaper-root': {
                border: `1px solid ${colors.color28}`,
            },
        }
    }
}
const TouchButton = (props: { date: Dayjs | null; error?: boolean; title: string; isDateForm: boolean } & ButtonProps) => {
    const styles = useStyles()

    const formatDate = useMemo(() => {
        const date = dayjs(props.date)
        return {
            onlyDate: props.date ? date.format(Constants.dayjsFormatDate) : null,
            onlyTime: props.date ? date.format(Constants.dayjsFormatTime) : null,
        }
    }, [props.date])

    return (
        <Button {...props} sx={{ ...styles.button, ...{ ...props?.error ? styles.error : {} } }} variant="text">
            <CustomPaper sx={styles.container} elevation={3}>
                <Typography sx={styles.title}>{props.title}</Typography>

                {
                    !props.date ?
                        <>
                            <Icon sx={styles.icon}>{icons('touch')}</Icon>

                            <Box sx={styles.dates}>
                                {props.isDateForm && <Typography>{Constants.dayjsFormatDate}</Typography>}

                                {!props.isDateForm && <Typography>HH:MM</Typography>}
                            </Box>
                        </>
                        :
                        (
                            <>
                                <Icon sx={styles.icon}>{icons('touch')}</Icon>
                                
                                <Box sx={styles.dates}>
                                    {props.isDateForm && <Typography>{formatDate.onlyDate}</Typography>}

                                    {!props.isDateForm && <Typography>{formatDate.onlyTime}</Typography>}
                                </Box>
                            </>
                        )
                }
            </CustomPaper>
        </Button>
    )
}

export { TouchButton }